import React from 'react';

const MainModalBox = ({ page }) => {
  return <div className="modalMimicPageModalBox">{page ? page : null}</div>;
};

export default MainModalBox;
